// @flow

import { observer } from "mobx-react";
import React from "react";

import AppearanceStore from "app/stores/AppearanceStore";

import Notifications from "app/components/Notifications/Notifications";

type Props = {
    success: ?(any[]),
    error: ?(any[])
};

@observer
export default class NotificationsContainer extends React.Component<Props> {
    componentWillMount() {
        if (this.props.error) {
            this.props.error.forEach((message: string) =>
                AppearanceStore.notifyError(message)
            );
        }

        if (this.props.success) {
            this.props.success.forEach((message: string) =>
                AppearanceStore.notifySuccess(message)
            );
        }
    }

    render() {
        const notifications = AppearanceStore.notifications;

        return (
            <Notifications
                items={notifications}
                onRemove={AppearanceStore.removeNotification}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/containers/NotificationsContainer.js